import {Component, OnInit, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {UrlConfig} from 'config/urlConfig';
import {NetworkService} from 'services/network.service';
import {SpinnerService} from 'services/spinner.service';


@Component({
    selector: 'tpc-energy-default',
    templateUrl: './energy-default.component.html',
    styleUrls: ['./energy-default.component.css']
})
export class EnergyDefaultComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmitted = false;
    public isZipValid = true;
    public homeForm: FormGroup;
    public countryList = [];
    public stateList = [];
    public isShown:boolean = true;
    public zipShown:boolean = true;

    constructor(private footerService: FooterNavbarService,
                private router: Router,
                private fb: FormBuilder,
                private networkService: NetworkService,
                private spinner: SpinnerService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            this.isZipValid = true;
            if (this.homeForm.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
        this.getCountryList();
    }

    private createForm() {
        this.homeForm = this.fb.group({
            country: ['',  [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(50),
                Validators.pattern(/^[A-Za-z0-9,.\-\s]+$/i)]],
            zip: ['', [
                Validators.minLength(3),
                Validators.maxLength(13),
                Validators.pattern(/^[A-Za-z0-9\-\s]+$/i)]],
            state: ['', this.stateValidator],
        });
    }

    private stateValidator = [
        Validators.minLength(1),
        Validators.maxLength(50),
        Validators.pattern(/^[A-Za-z0-9,.\-\s]+$/i)
    ];

    private next() {
        let countryid = this.homeForm.get('country').value;
        let subregion = (this.homeForm.get('state').value.length > 0)? this.homeForm.get('state').value : 'na';
        let zip = (this.homeForm.get('zip').value.length > 0)? this.homeForm.get('zip').value : '0000',
            prop = {'ZIP': zip};

        if (this.stateList.length>0)
        {
            if (zip == '0' && this.stateList.length > 50) {
                this.isZipValid = false;
                return;
            }
            else if(this.homeForm.get('state').value.length=='0')
            {
                this.isZipValid = false;
                return;
            }
            else {
                this.router.navigate(['/individual/home/add', {
                    zip: zip, subregion: subregion, countryid: countryid
                }]);
            }
        }

        this.spinner.show();
        this.networkService.post(UrlConfig.getUrl('verifyZipCode'), prop).subscribe(
            response => {
                let isZipValid = response.length;
                this.spinner.hide();

                if (!isZipValid && this.stateList.length>50) {
                    this.isZipValid = false;
                    return;
                }

                this.router.navigate(['/individual/home/add', {
                    zip: zip, subregion: subregion, countryid: countryid
                }]);
            }
        );
    }

    checkError(param) {
        return this.homeForm.get(param).status === 'INVALID' && (this.isFormSubmitted || this.homeForm.get(param).touched);
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }

    private getCountryList(): void {
        this.spinner.show();
        this.networkService.post(UrlConfig.getUrl('getStateAndCountry'), { }).subscribe(
        country => {
                this.countryList = country;
                this.spinner.hide();
            }
        );
    }

    public getStateList(state) {
        this.spinner.show();
        this.networkService.post(UrlConfig.getUrl('getStateAndCountry'), {Country: 'US', CountryID: state}).subscribe(
            states => {
                this.stateList = states.sort((a, b) => a.StateAB.localeCompare(b.StateAB));
                if(this.stateList.length > 0)
                {
                    if(this.stateList.length > 50)
                        this.zipShown = true;
                    else
                        this.zipShown = false;
                    //this.form.get('state').setValidators(this.stateValidator.concat(Validators.required));
                    this.isShown = true;
                    if(this.stateValidator.length == 3)
                        this.stateValidator = this.stateValidator.concat([Validators.required]);
                    this.homeForm.updateValueAndValidity();
                    //this.form.get('zip').setValidators([Validators.required]);
                }
                else
                {
                    this.isShown = false;
                    this.zipShown = false;
                    if(this.stateValidator.length == 4)
                        this.stateValidator.splice(this.stateValidator.length - 1,this.stateValidator.length);
                    this.homeForm.get('state').setValidators(this.stateValidator);
                }
                this.spinner.hide();
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/shared/main/energy/energy-default/energy-default.component.ts